"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const store_1 = require("../../../reviews-modal/store");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const constants_1 = require("../../../reviews-modal/slice/sliceReview/constants");
const sliceReview_1 = require("../../../reviews-modal/slice/sliceReview");
const helper_1 = require("../../helper");
const LinkReviews_1 = __importDefault(require("./LinkReviews"));
const DocumentReviewGrid = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../DocumentReviewGridComponent'))));
const ReviewModal = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../reviews-modal'))));
const ReviewTicket = ({ jobId, jobName, documentReviewCount = 0, taskId = 0, }) => {
    const [openModalReview, setOpenModalReview] = (0, react_1.useState)(false);
    const [createFirstReview, setCreateFirstReview] = (0, react_1.useState)(false);
    const [reviewAmount, setReviewAmount] = (0, react_1.useState)(documentReviewCount);
    const [openLinkReviews, setOpenLinkReviews] = (0, react_1.useState)(false);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const handleClick = () => {
        if (jobId && jobName && taskId > 0) {
            setOpenModalReview(true);
            dispatch((0, sliceReview_1.openModal)({
                status: constants_1.MODE.create,
                id: jobId,
                label: jobName,
                ticketId: taskId,
            }));
        }
    };
    const getParamFilterTicket = () => (0, helper_1.filterParams)({ ticket_id: taskId });
    const handleCreateReview = () => {
        if (reviewAmount === 0) {
            setCreateFirstReview(true);
            setReviewAmount(documentReviewCount + 1);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "reviewTicket-grid__root" },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['reviewTicket-grid___header'] },
                react_1.default.createElement("label", { className: styles_modules_less_1.default['grid-header__title'] }, "Reviews linked to Task"),
                helper_1.CREATE_REVIEW_PERMISSION === 'y' && (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-ticket__actions'] },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default.grid_createReview__btn, onClick: () => {
                            setOpenLinkReviews(true);
                        } },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-link', styles_modules_less_1.default['create-btn__icon']) }),
                        react_1.default.createElement("span", { className: styles_modules_less_1.default['create-btn__text'] }, "Link Reviews")),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default.grid_createReview__btn, onClick: handleClick },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-plus', styles_modules_less_1.default['create-btn__icon']) }),
                        react_1.default.createElement("span", { className: styles_modules_less_1.default['create-btn__text'] }, "Create review"))))),
            (0, react_1.useMemo)(() => ((documentReviewCount && taskId) || createFirstReview) && (react_1.default.createElement(DocumentReviewGrid, { paramFilter: getParamFilterTicket(), isTaskForm: true, ticketId: taskId || 0, rejectFilterJobId: true })), [taskId, createFirstReview]),
            !((documentReviewCount && taskId) || createFirstReview) && (react_1.default.createElement("div", { className: styles_modules_less_1.default['empty-review__root'] },
                react_1.default.createElement("b", null, "NO REVIEWS LINKED TO THIS TASK. "),
                react_1.default.createElement("span", null, "Click 'Create Review' or 'Link to Review' to link a Review to this Task.")))),
        openModalReview && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading ...") },
            react_1.default.createElement(ReviewModal, { onCloseReviewModal: () => setOpenModalReview(false), onCreated: handleCreateReview }))),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
            react_1.default.createElement(LinkReviews_1.default, { isOpen: openLinkReviews, ticketId: taskId, onLinkReview: handleCreateReview, jobId: jobId, jobName: jobName, closeModal: () => {
                    setOpenLinkReviews(false);
                } }))));
};
exports.default = ReviewTicket;
